import React from 'react';
import { Show, ReferenceField, SimpleShowLayout, usePermissions } from 'react-admin';
import BackButton from '../components/BackButton';
import CustomTextField from '../components/CustomTextField';
import ShowFormattedDate from '../components/ShowFormattedDate';
import CardActions from "@material-ui/core/CardActions";
import LocationSearchingIcon from '@material-ui/icons/LocationSearching';

const InspectionShowActions = (props) => {
    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
        </CardActions>
    );
};

const InspectionShowGeneral = ({ record }) => {
    const { date, code } = record;
    var defaultShowComponent = <span className="text-secondary" style={{ fontStyle: 'italic' }}>empty</span>;

    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;

    return (
        <div className="row">
            <div className="col-12 col-xs-12">
                <div className="row g-2 g-lg-2 mb-2">
                    <div className="col">
                        <div>
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Code</h6>
                            {code ? code.length > 0 ? <span className="fw-italic m-0 p-0">{code}</span> : defaultShowComponent : defaultShowComponent}
                        </div>
                    </div>
                    <div className="col">
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>System Name </h6>
                        <ReferenceField style={{ margin: '0px' }} label="" source="system_id" resource="systems" reference="systems" link={isAdmin ? 'show' : ''}><CustomTextField className="m-0 p-0" source="name" /></ReferenceField>
                    </div>
                    <div className="col">
                        <div>
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Date</h6>
                            {date ? date.length > 0 ? <ShowFormattedDate date={date} /> : defaultShowComponent : defaultShowComponent}
                        </div>
                    </div>
                    <div className="col">
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Inspector</h6>
                        <ReferenceField style={{ margin: '0px' }} label="" source="inspector_id" resource="inspectors" reference="inspectors" link={isAdmin ? 'show' : ''}><CustomTextField className="m-0 p-0" source="display_name" /></ReferenceField>
                    </div>
                </div>
            </div>
        </div>
    );
};

const InspectionShowElements = ({ record }) => {
    const { inspected } = record;

    var elementskey = [];
    for (const key in inspected) {

        var frequencies = [];
        inspected[key].forEach(f => { frequencies.push(<li class="list-group-item fw-light text-secondary">{f.charAt(0).toUpperCase() + f.slice(1)}</li>) });

        elementskey.push(
            <ul className="list-group mt-3" id={key.replace(' ', '') + '-ul'}>
                <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">{key.charAt(0).toUpperCase() + key.slice(1)}</li>
                {frequencies}
            </ul>
        );
    }

    return (
        <div>
            <div className="mt-0 pt-0">
                {elementskey.filter(element => element.props.id == "main-ul")[0]}
                {elementskey.filter(element => element.props.id == 'antifreeze-ul')[0]}
                {elementskey.filter(element => element.props.id == 'firepump-ul')[0]}
                {elementskey.filter(element => element.props.id == 'trip-ul')[0]}
            </div>
        </div>
    );
};

const InspectionShow = (props) => (
    <>
        <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Inspection</h3>
        <Show title=" " actions={<InspectionShowActions />} {...props}>
            <SimpleShowLayout>
                <InspectionShowGeneral record={{ ...props }} />

                <h6 className="font-weight-normal pt-2">{<LocationSearchingIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Inspected</h6>
                <InspectionShowElements record={{ ...props }} />
            </SimpleShowLayout>
        </Show>
    </>
);

export default InspectionShow;